import { render } from "./DialogModal.vue?vue&type=template&id=3f5da7af"
import script from "./DialogModal.vue?vue&type=script&lang=js"
export * from "./DialogModal.vue?vue&type=script&lang=js"
script.render = render

export default script